import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function SolutionSections() {
  const fadeIn = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut'
      }
    }
  };
  return <div className="space-y-24 py-12 px-6 max-w-3xl mx-auto text-[#3D3631]" data-id="element-138">
      {/* Método Doble Ancla */}
      <motion.section initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={fadeIn} className="text-center" data-id="element-139">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#2A6B6B] mb-4" data-id="element-140">
          La solución: el Método Doble Ancla
        </h2>
        <p className="text-xl md:text-2xl font-serif italic text-[#5C544E] mb-10" data-id="element-141">
          Doble Ancla = Movimiento Suave + Repetición de Estabilidad
        </p>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-142">
          <div className="bg-white p-8 rounded-2xl shadow-md border-t-8 border-[#8BAA8B]" data-id="element-143">
            <h3 className="font-serif text-xl font-bold text-[#2A6B6B] mb-3" data-id="element-144">
              Movimiento Suave
            </h3>
            <p className="text-[#8BAA8B] font-bold text-sm uppercase tracking-wide mb-4" data-id="element-145">
              5–7 min
            </p>
            <p className="text-lg" data-id="element-146">
              Despierta piernas, cadera, postura y control.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-md border-t-8 border-[#D4654A]" data-id="element-147">
            <h3 className="font-serif text-xl font-bold text-[#2A6B6B] mb-3" data-id="element-148">
              Repetición de Estabilidad
            </h3>
            <p className="text-[#D4654A] font-bold text-sm uppercase tracking-wide mb-4" data-id="element-149">
              2–5 min
            </p>
            <p className="text-lg" data-id="element-150">
              Entrenas equilibrio útil para tu vida real.
            </p>
          </div>
        </div>

        <p className="mt-10 text-lg md:text-xl font-medium" data-id="element-151">
          No necesitas equipo. No necesitas gimnasio. Necesitas una silla firme,
          una pared cerca y un plan que no te asuste.
        </p>
      </motion.section>

      {/* Qué incluye exactamente */}
      <motion.section initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={fadeIn} className="bg-[#E8DDD0]/20 p-8 md:p-12 rounded-3xl" data-id="element-152">
        <h2 className="font-serif text-3xl font-bold text-[#2A6B6B] mb-8 text-center" data-id="element-153">
          Dentro del PDF recibes:
        </h2>
        <ul className="space-y-6" data-id="element-154">
          {['Guía paso a paso con ejercicios de bajo impacto (explicados sin tecnicismos)', 'Checklist anti-caídas para tu casa (baño, pasillos, tapetes, luz, calzado)', 'Plan de 30 días (5 días ON / 2 OFF) para que no tengas que pensar', 'Modificaciones si te molesta rodilla, cadera o espalda', 'Marcador semanal de progreso (para ver cambios sin obsesión)'].map((item, i) => <li key={i} className="flex items-start text-lg md:text-xl" data-id="element-155">
              <div className="bg-[#8BAA8B] rounded-full p-1 mt-1 mr-4 flex-shrink-0" data-id="element-156">
                <Check className="h-4 w-4 text-white" strokeWidth={3} data-id="element-157" />
              </div>
              <span data-id="element-158">{item}</span>
            </li>)}
        </ul>
      </motion.section>

      {/* Lo que NO es */}
      <motion.section initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={fadeIn} className="text-center max-w-2xl mx-auto" data-id="element-159">
        <h2 className="font-serif text-2xl font-bold text-[#3D3631] mb-6" data-id="element-160">
          Esto NO es:
        </h2>
        <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-8 mb-8" data-id="element-161">
          {['una rutina intensa', 'un programa de «cambios extremos»', 'ni algo que te haga sentir culpable'].map((item, i) => <div key={i} className="flex items-center justify-center text-lg text-[#5C544E]" data-id="element-162">
              <X className="h-5 w-5 text-[#D4654A] mr-2" data-id="element-163" />
              <span data-id="element-164">{item}</span>
            </div>)}
        </div>
        <p className="text-xl font-serif italic text-[#2A6B6B]" data-id="element-165">
          Es una guía práctica para mujeres reales.
        </p>
      </motion.section>

      {/* Cómo se usa */}
      <motion.section initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={fadeIn} data-id="element-166">
        <h2 className="font-serif text-3xl font-bold text-[#2A6B6B] mb-10 text-center" data-id="element-167">
          Cómo se usa
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-168">
          {[{
          step: 1,
          text: 'Abres el PDF'
        }, {
          step: 2,
          text: 'Sigues el día que toca'
        }, {
          step: 3,
          text: 'Haces 7–12 minutos'
        }, {
          step: 4,
          text: 'Cierras'
        }].map(item => <div key={item.step} className="bg-white p-6 rounded-xl shadow-sm text-center border border-[#E8DDD0]" data-id="element-169">
              <span className="block text-4xl font-serif font-bold text-[#E8DDD0] mb-2" data-id="element-170">
                {item.step}
              </span>
              <p className="font-medium text-lg" data-id="element-171">{item.text}</p>
            </div>)}
        </div>
        <p className="text-center mt-8 text-xl font-medium text-[#5C544E]" data-id="element-172">
          Sin ruido. Sin complicarte.
        </p>
      </motion.section>
    </div>;
}